import FormField, { BaseFormFieldProps } from './FormField';
import React, { Component } from 'react';
import { MultiSelect } from '@blueprintjs/select';
import { Button } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';

interface SelectInputFormFieldProps<T, V> extends BaseFormFieldProps {
  itemValueGetter: (item: T) => V;
  valueItemGetter: (value: V) => T;
  placeholderSelection?: TLCode;
  allowEmpty?: boolean;
  identifier: string;
  elementLabel: string;
  labelSelectAnElement?: string;
  afterItemSelected?: (id: number | undefined) => void;
  tagRenderer: (item: T) => React.ReactNode;
}

class MultiSelectInputFormField<T, V> extends Component<SelectInputFormFieldProps<T, V>> {
  public static ofType<T, V>() {
    return MultiSelectInputFormField as new (props: SelectInputFormFieldProps<T, V>) => MultiSelectInputFormField<T, V>;
  }

  get TypedMultiSelectInput() {
    return MultiSelect.ofType<T>();
  }

  render() {
    const {
      items,
      itemPredicate,
      itemValueGetter,
      valueItemGetter,
      inputValueRenderer,
      itemRenderer,
      placeholderSelection,
      allowEmpty,
      identifier,
      elementLabel,
      labelSelectAnElement,
      afterItemSelected,
      clearSelectedItems
    } = this.props;

    let finalItems = items;

    if (allowEmpty) {
      const emptyObject: any = {};
      emptyObject[identifier] = null;
      emptyObject[elementLabel] = labelSelectAnElement != null ? labelSelectAnElement : 'Select an element';
      finalItems = [emptyObject, ...finalItems];
    }

    return (
      <FormField {...this.props}>
        {({ input: { onChange, value, ...rest } }) => {
          const TypedMultiSelectInput = this.TypedMultiSelectInput;
          let selectedItems = Array.isArray(value) ? value.map(valueItemGetter) : [];

          return (
            <div style={{ display: 'flex', alignItems: 'center'}}>
              <TypedMultiSelectInput
                items={finalItems}
                selectedItems={selectedItems}
                itemPredicate={itemPredicate}
                itemRenderer={itemRenderer}
                resetOnSelect={true}
                popoverProps={{ minimal: true }}
                tagRenderer={this.props.tagRenderer}
                onItemSelect={(item) => {
                  const itemValue = itemValueGetter(item);
                  const currentValues = Array.isArray(value) ? [...value] : [];
                  const alreadySelected = currentValues.includes(itemValue);
                  const newSelection = alreadySelected
                    ? currentValues.filter((v) => v !== itemValue)
                    : [...currentValues, itemValue];
                  onChange(newSelection);
                }}
                {...rest}
              />
              <Button minimal rightIcon="cross" onClick={() => { clearSelectedItems() }} />
            </div>
          );
        }}
      </FormField>
    );
  }
}

export default MultiSelectInputFormField;
